<template>
    <div class="modal-container">
        <PreLoader v-if="isLoading"/>
        <div class="lesson-day">{{objDay[sendScheduleObj.weekDay]}} - {{$t('lesson')}} {{ selectedShiftTime.name}}</div>
        <v-form ref="scheduleForm" v-if="!classViewSchedule" style="padding: 0; margin: 0">
            <template v-if="!isArchiveMode">
                <div class="form-data">
                    <div class="main">
                        <div class="teacher-title">{{ teacherTitleCourse }}</div>
                        <template v-if="dataObj.mode === 'create' || dataObj.mode === 'edit'">
                            <h4>{{ dataObj.mode === 'create' ? $t('addSchedule') : $t('editSchedule') }}</h4>
                            <div class="delete-schedule" v-if="dataObj.mode === 'edit'">
                                <span class="archive" @click="isArchiveMode=true">{{$t('sendToArchive')}}</span>
                                <DeleteIcon @click="removeSchedule"/>
                            </div>
                            <div class="content">
                                <v-select :items="classes" :rules="required" item-text="classTitle" item-value="id" :no-data-text="$t('no_data')"
                                          :label="$t('chooseClass')" v-model="sendScheduleObj.classId" @change="changeClass"/>
                                <div class="checkboxes" v-if="sendScheduleObj.classId">
                                    <label for="group" class="is-group">
                                        <span>{{$t('group')}}</span>
                                        <input id="group" type="checkbox" v-model="sendScheduleObj.grouped"
                                               @change="getSelectedClassStudents">
                                    </label>
                                    <div class="replace-btn">
                                        <label for="replace-s">
                                            <input id="replace-s" type="checkbox" v-model="sendScheduleObj.replace"
                                                   @change="setReplaceDate">
                                            {{$t('replaceTeacher')}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="select-student" v-if="sendScheduleObj.grouped">
                        <span class="span-txt">Выбрать группу</span>
                        <v-btn-toggle class="btn-toggle" v-model="toggle_exclusive" style="color: green">
                            <v-btn dense outlined v-for="item in groups" :key="item.id"
                                   class="btn-toggle_btn" @click="onSelectGroupF(item.id)">{{item.title}}</v-btn>
                        </v-btn-toggle>
                        <span v-if="!sendScheduleObj.group.other" style="color: #707683; font-size: 14px;"
                              v-show="false">Текущая группа</span>
                        <v-select :items="groups" item-text="title" item-value="id" style="margin-top: 8px" v-show="false"
                                  v-model="sendScheduleObj.group.id" @change="onSelectGroup" disabled outlined dense
                                  v-if="!sendScheduleObj.group.other" :rules="required"/>
                        <div v-if="sendScheduleObj.group.other"
                             style="color: #707683; font-size: 14px; padding-bottom: 8px">Новая группа</div>
                        <v-text-field :rules="required" v-model="sendScheduleObj.group.title"
                                      v-if="sendScheduleObj.group.other" outlined dense/>
                        <div class="student" v-for="student in students" :key="student.id">
                            <label :for="student.id">
                                <input :id="student.id" type="checkbox" v-model="student.checked"
                                       @change="deleteStudentCourse($event, student), addStudent($event, student)">
                                <span v-html="student.fullName"/>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="btn-actions">
                    <v-btn color="red" @click="$emit('close')">{{ $t('cancel') }}</v-btn>
                    <v-btn color="green" @click="onSave">{{ $t('save') }}</v-btn>
                </div>
            </template>
            <div class="confirm-archive" v-if="isArchiveMode">
                <h4>{{ $t('archiveQuestion') }}</h4>
                <div class="btn-actions">
                    <v-btn color="red" @click="isArchiveMode=false">{{ $t('cancel') }}</v-btn>
                    <v-btn color="green" @click="archiveSchedule">{{ $t('yes') }}</v-btn>
                </div>
            </div>
        </v-form>

        <!--CLASS VIEW-->
        <v-form ref="scheduleForm" v-if="classViewSchedule">
            <h4>{{ mode === 'create' ? $t('addCourse') : $t('edit') }}</h4>
            <div class="delete-schedule" v-if="mode === 'edit'">
                <span></span>
                <DeleteIcon @click="removeSchedule"/>
            </div>
            <v-autocomplete :items="allTeachers" :rules="required" :item-text="getTeacherAndCourseName"
                            item-value="id" :label="$t('course')" v-model="sendScheduleObj.instrCourseId"
                            @change="onSelectScheduleCourse"/>
            <div class="replace-btn">
                <label for="replace">
                    <input id="replace" type="checkbox" v-model="sendScheduleObj.replace" @change="setReplaceDate">
                    {{ $t('replaceTeacher') }}
                </label>
            </div>
            <div class="btn-actions">
                <v-btn color="red" @click="$emit('close')">{{ $t('cancel') }}</v-btn>
                <v-btn color="green" @click="onSave" :disabled="!sendScheduleObj.instrCourseId">{{ $t('save') }}</v-btn>
            </div>
        </v-form>
    </div>
</template>

<script>
import DeleteIcon from '@/components/icons/DeleteIcon'
import PreLoader from '@/components/preloader/PreLoader'
import StudentCourseService from '@/_services/student-course.service'
import { StudentService } from '@/_services/student.service'
import ScheduleWeekService from '@/_services/schedule-week.service'
import { GroupService } from '../../_services/group.service'
const studentService = new StudentService()
const groupService = new GroupService()

export default {
  props: {
    mode: String,
    objDay: Object,
    sendScheduleObj: Object,
    selectedShiftTime: Object,
    classes: Array,
    classViewSchedule: Boolean,
    allTeachers: Array,
    teacherTitleCourse: String
  },
  components: {
    DeleteIcon,
    PreLoader
  },
  data () {
    return {
      toggle_exclusive: 0,
      langObj: {
        ru: 'courseTitle',
        kg: 'courseTitleKG',
        en: 'courseCode'
      },
      required: [v => !!v || this.$t('Обязательное поле')],
      isLoading: false,
      dataObj: {
        mode: this.mode
      },
      students: [],
      studentCourseBatchArr: [],
      allStIds: [],
      studentCourseRequest: {
        chronicleId: 0,
        classId: 0,
        courseId: 0,
        instructorId: 0
      },
      isArchiveMode: false,
      groups: []
    }
  },
  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools[0]
    },
    currentLang () {
      return this.$root.$i18n.locale
    }
  },
  async created () {
    if (!this.classViewSchedule && this.mode === 'edit' && this.sendScheduleObj.grouped) {
      await this.fetchGroups()
      await this.getSavedStudentCourses()
    }
  },
  methods: {
    getTeacherAndCourseName (teacher) {
      return teacher[this.langObj[this.currentLang]] + ' - ' + teacher.instructorTitle
    },

    onSelectScheduleCourse (instrCourseId) {
      const instrCourseObj = this.allTeachers.find((instrCourse) => instrCourse.id === instrCourseId)
      this.sendScheduleObj.instructorId = instrCourseObj.instructorId
      this.sendScheduleObj.courseId = instrCourseObj.courseId
      this.sendScheduleObj.courseCode = instrCourseObj.courseCode
      this.sendScheduleObj.courseTitle = instrCourseObj.courseTitle
      this.sendScheduleObj.courseTitleKG = instrCourseObj.courseTitleKG
    },

    onSave () {
      if (this.$refs.scheduleForm.validate()) {
        this.isLoading = true
        this.$nextTick(() => {
          setTimeout(() => {
            this.$emit('close', { type: 'save', mode: this.dataObj.mode })
            this.submitSaveStudentCourse()
          }, 10)
        })
      }
    },

    removeSchedule () {
      this.isLoading = true
      this.$nextTick(() => {
        setTimeout(() => {
          this.$emit('close', { type: 'delete', scheduleId: this.sendScheduleObj.id })
        }, 10)
      })
    },

    changeClass () {
      this.sendScheduleObj.groupTitle = ''
      this.sendScheduleObj.grouped = false
      this.students = []
    },

    getSelectedClassStudents (e) {
      if (e.currentTarget.checked) {
        this.getSavedStudentCourses()
        this.fetchGroups()
      }
    },

    fetchClassStudents () {
      this.isLoading = true
      studentService.getByClassAndGroupAndCourse(this.sendScheduleObj.classId).then((res) => { // , this.sendScheduleObj.group.id, this.sendScheduleObj.courseId).then((res) => {
        this.students = res.map((student) => {
          student.fullName = student.surname + ' ' + student.name
          return student
        })
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    getSavedStudentCourses () {
      let stArr = []
      if (this.mode === 'create') {
        studentService.getByClassAndGroupAndCourse(this.sendScheduleObj.classId).then((res) => { // , 0, 0).then((res) => {
          if (res.length === 0) {
            this.$toast.success('В этом классе нет учеников')
          } else {
            this.students = res.map((student) => {
              student.fullName = student.surname + ' ' + student.name
              this.allStIds.forEach(el => {
                if (student.id === el) {
                  student.fullName = '' + student.surname + ' ' + student.name + ''
                }
              })
              return student
            })
          }
          this.isLoading = false
        }).catch((err) => {
          this.$toast.error(err)
          this.isLoading = false
        })
      } else {
        studentService.getByClassAndGroupAndCourse(this.sendScheduleObj.classId) // , 0, this.sendScheduleObj.courseId)
          .then(async (res) => {
            stArr = res.map((student) => {
              student.fullName = student.surname + ' ' + student.name
              student.checked = false
              return student
            })
            let currGroupIds = []
            if (this.groups.find(el => el.id === this.sendScheduleObj.group.id)) {
              currGroupIds = this.groups.find(el => el.id === this.sendScheduleObj.group.id).studentIds
            }
            stArr.forEach((st) => {
              for (let i = 0; i < currGroupIds.length; i++) {
                if (st.id === currGroupIds[i]) st.checked = true
              }
            })
            this.isLoading = true
            StudentCourseService.getListInterfaceByClass(
              {
                chronicleId: this.school.chronicleId,
                classId: this.sendScheduleObj.classId,
                courseId: this.sendScheduleObj.courseId,
                instructorId: this.sendScheduleObj.instructorId
              }
            ).then((res) => {
              res.forEach((studentCourse) => {
                this.students = stArr.map((student) => {
                  if (student.checked && studentCourse.studentId === student.id) {
                    student.originChecked = true
                    student.studentCourseId = studentCourse.id
                  }
                  return student
                })
              })
              this.isLoading = false
            }).catch((err) => {
              this.$toast.error(err)
              this.isLoading = false
            })

            // await this.fetchClassStudents()
            // this.isLoading = true
            // this.studentCourseRequest.classId = this.sendScheduleObj.classId
            // this.studentCourseRequest.instructorId = this.sendScheduleObj.instructorId
            // this.studentCourseRequest.courseId = this.sendScheduleObj.courseId
            // this.studentCourseRequest.chronicleId = this.school.chronicleId
            // setTimeout(() => {
            //   StudentCourseService.getListInterfaceByClass(this.studentCourseRequest).then((res) => {
            //     res.forEach((studentCourse) => {
            //       this.students = this.students.map((student) => {
            //         if (studentCourse.studentId === student.id) {
            //           student.checked = true
            //           student.originChecked = true
            //           student.studentCourseId = studentCourse.id
            //         }
            //         return student
            //       })
            //     })
            //     stArr.forEach((el) => {
            //       for (let i = 0; i < this.students.length; i++) {
            //         if (el.id === this.students[i].id) {
            //           el.checked = true
            //         }
            //       }
            //     })
            //     this.students = stArr
            //     this.isLoading = false
            //   }).catch((err) => {
            //     this.$toast.error(err)
            //     this.isLoading = false
            //   })
            // })
          }).catch((err) => {
            this.$toast.error(err)
            this.isLoading = false
          })
      }
    },

    async submitSaveStudentCourse () {
      this.studentCourseBatchArr = []
      if (this.sendScheduleObj.grouped) {
        this.students.filter((i) => i.checked).forEach((student) => {
          const studentCourse = {
            archived: false,
            chronicleId: this.school.chronicleId,
            classId: this.sendScheduleObj.classId,
            courseId: this.sendScheduleObj.courseId,
            instructorId: this.sendScheduleObj.instructorId,
            studentId: student.id
          }
          this.studentCourseBatchArr.push(studentCourse)
        })
        if (this.studentCourseBatchArr.length) {
          try {
            await StudentCourseService.createBatch(this.studentCourseBatchArr)
          } catch (err) {
            this.$toast.error(err)
          }
        }
      }
    },

    deleteStudentCourse (e, student) {
      if (!e.currentTarget.checked && student.originChecked) {
        StudentCourseService.removeStudCourse(student.studentCourseId).then(() => {
          student.originChecked = false
        })
      }
    },

    addStudent (e, student) {
      this.sendScheduleObj.group.changed = true
      if (e.currentTarget.checked) {
        this.sendScheduleObj.group.studentIds.push(student.id)
      } else {
        this.sendScheduleObj.group.studentIds.splice(this.sendScheduleObj.group.studentIds.indexOf(student.id), 1)
      }
    },

    setReplaceDate (e) {
      if (e.currentTarget.checked) {
        this.sendScheduleObj.replaceDate = new Date().toLocaleDateString('ru')
      } else {
        this.sendScheduleObj.replaceDate = ''
      }
    },

    archiveSchedule () {
      this.isLoading = true
      const archiveObj = {
        classId: this.sendScheduleObj.classId,
        courseId: this.sendScheduleObj.courseId,
        instructorId: this.sendScheduleObj.instructorId,
        replaceDate: new Date().toLocaleDateString('ru')
      }
      ScheduleWeekService.archiveSchedules(archiveObj).then(() => {
        this.$emit('close', { archiveData: archiveObj })
        this.$toast.success('Успешно отправлены в архив!')
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    async fetchGroups () {
      if (this.sendScheduleObj.grouped) {
        groupService.getByClass(this.sendScheduleObj.classId, this.sendScheduleObj.courseId).then((res) => {
          this.groups = res
          if (res.length < 2) {
            this.groups.push(
              {
                id: null,
                title: 'Создать группу',
                studentIds: [],
                other: true
              }
            )
          }
          this.groups.forEach(el => {
            for (let i = 0; i < el.studentIds.length; i++) {
              this.allStIds.push(el.studentIds[i])
            }
          })
          this.toggle_exclusive = this.groups.indexOf(this.groups.find(el => el.id === this.sendScheduleObj.group.id))
          this.matchStudentGroup()
        }).catch((err) => {
          this.$toast.error(err)
        })
      }
    },

    matchStudentGroup () {
      if (this.groups.length) {
        const group = this.groups.find(el => el.id === this.sendScheduleObj.group.id)
        if (group !== undefined) {
          this.sendScheduleObj.group.studentIds = group.studentIds
          this.sendScheduleObj.group.other = group.other
          this.sendScheduleObj.group.changed = false
          if (group.id !== null) {
            this.sendScheduleObj.group.title = group.title
            this.students.forEach((student) => {
              student.checked = group.studentIds.includes(student.id)
              student.originChecked = student.checked
            })
          } else {
            this.sendScheduleObj.group.title = ''
            this.isLoading = true

            studentService.getByClassAndGroupAndCourse(this.sendScheduleObj.classId).then((res) => { // , 0, this.sendScheduleObj.courseId).then((res) => {
              this.students = res.map((student) => {
                student.fullName = student.surname + ' ' + student.name
                this.allStIds.forEach(el => {
                  if (student.id === el) {
                    student.fullName = '' + student.surname + ' ' + student.name + ''
                  }
                })
                return student
              })
              this.isLoading = false
            }).catch((err) => {
              this.$toast.error(err)
              this.isLoading = false
            })
          }
        }
      }
    },

    onSelectGroupF (id) {
      this.sendScheduleObj.group.id = id
      this.onSelectGroup()
    },

    async onSelectGroup () {
      if (this.sendScheduleObj.group.id !== null) {
        await this.getSavedStudentCourses()
      }
      await this.fetchGroups()
    }
  }
}
</script>

<style lang="scss">
@media (max-width: 420px) {
    .form-data {
        flex-wrap: wrap!important;
    }
    .select-student{
        border: none!important;
        margin: 0!important;
        padding: 0!important;
    }
}
.span-txt{
    color: #707683; font-size: 14px
}
.btn-toggle{
    display: flex; flex-direction: row; color: green; width: 100%; padding: 8px 0 12px 0; gap: 8px; flex-wrap: wrap
}
.btn-toggle_btn{
    min-width: 31.6%; width: max-content;
}
    .modal-container {
        //min-height: 600px;
        //max-height: 800px;
        //height: max-content;
        //max-height: 70%;
        //overflow-y: auto;
        .form-data {
            display: flex;
            justify-content: center;
            margin-top: 20px;
            gap: 16px;
            flex-wrap: nowrap;
            .main {
                width: 100%;
                //min-width: 400px;
            }
            .select-student {
                width: 100%;
                //min-width: 350px;
                //height: max-content;
                //max-height: 300px;
                //overflow-y: auto;
                margin-left: 15px;
                padding-left: 15px;
                border-left: 1px solid #b7b7b7;
                .student {
                    border-bottom: 1px solid #c3c3c3;
                    padding: 5px 0;
                    label {
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                    }
                    span {
                        margin-left: 8px;
                        font-size: 17px;
                        width: 90%;
                        display: inline-block;
                        white-space: nowrap;
                        overflow-x: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
            .checkboxes {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
        }
        .lesson-day {
            text-align: center;
            font-weight: bold;
        }
        .teacher-title {
            text-align: center;
            font-weight: bold;
            margin: 10px 0;
        }
        .delete-schedule {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 20px 0;
            .archive {
                background: #ff0000;
                color: #fff;
                padding: 3px 5px;
                border-radius: 4px;
                cursor: pointer;
                font-size: 13px;
                font-weight: bold;
            }
        }
        .add-group-class {
            border: 1px solid;
            display: inline-block;
            color: #045ea5;
            padding: 1px 5px;
            border-radius: 5px;
            cursor: pointer;
            transform: translateY(-15px);
            background: #f8f8f8;
        }
        .groups {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 15px 0 20px;
            .group {
                color: #fff;
                font-size: 16px;
                padding: 2px 5px;
                border-radius: 5px;
                margin-right: 15px;
                background: #2196F3;
                cursor: pointer;
                text-align: center;
            }
        }
        .group-info {
            text-align: center;
            font-size: 18px;
        }
        .is-group {
            display: flex;
            align-items: center;
            cursor: pointer;
            span {
                margin-right: 5px;
                color: #7b7b7b;
            }
        }
        .btn-actions {
            flex-wrap: wrap;
            button {
                &.green {
                    background: #07980d !important;
                }
                &.red {
                    background: #da1507 !important;
                }
                &.primary {
                    background: #1976d2 !important;
                }
            }
            .close {
                margin-top: 10px;
            }
        }
        .v-select__selections {
            height: 40px;
            overflow: hidden;
        }
        .replace-btn {
            text-align: right;
            label {
                border: 1px solid #024377;
                padding: 3px 5px;
                border-radius: 4px;
                color: #024377;
                cursor: pointer;
                font-size: 14px;
                input {
                    margin-right: 4px;
                    transform: translateY(1px);
                }
            }
        }
    }
    .theme--light.v-messages {
        color: red;
    }
@media (max-width: 420px) {

}
</style>
